// @flow

export const isBrowser =
  typeof window === 'object' &&
  typeof document === 'object' &&
  document.nodeType === 9;
